import {
  Box,
  Chip,
  createStyles,
  lighten,
  makeStyles,
  TextField,
  Theme,
  Typography,
  useTheme,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import * as React from 'react';
import { Dispatch, SetStateAction } from 'react';
import { TagGroupGq } from '../../../graphql/projects/models/TagGroupGq';
import { AnalysisFilterState } from '../../../pages/AnalysisPage/Filter/analysisFilterState';
import PrimOutCheckbox from '../Checkbox/PrimOutCheckbox';

export interface MultiTagGroupAutocompleteProps {
  tagGroups: TagGroupGq[];
  analysisFilterState: AnalysisFilterState;
  setAnalysisFilterState: Dispatch<SetStateAction<AnalysisFilterState>>;
}

const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    chipBgColor: {
      backgroundColor: lighten(theme.palette.primary.main, 0.8),
    },
    deleteIconSmall: {
      color: theme.palette.primary.main,
    },
    inputMarginDense: {
      paddingBottom: '3px',
    },
  })
);

const MultiTagGroupAutocomplete: React.FC<MultiTagGroupAutocompleteProps> = ({
  tagGroups,
  analysisFilterState,
  setAnalysisFilterState,
}) => {
  // Styling
  const theme = useTheme();
  const classes = useClasses({});

  return (
    <Box display={'flex'} alignItems={'center'} width={'100%'}>
      <Box pr={1}>
        <Typography variant={'body2'}>{'Tag groups:'}</Typography>
      </Box>
      <Box flexGrow={1}>
        <Autocomplete
          multiple
          disableCloseOnSelect
          filterSelectedOptions
          fullWidth
          size="small"
          limitTags={7}
          options={tagGroups}
          value={tagGroups.filter((tg) => analysisFilterState?.tagGroupIds.includes(tg.id))}
          getOptionSelected={(option, value) => option.name === value.name}
          onChange={(event: any, value: TagGroupGq[], reason: string) => {
            const ids = value.map((tg) => tg.id);
            setAnalysisFilterState((prev) => ({ ...prev, tagGroupIds: ids }));
          }}
          getOptionLabel={(option) => option?.name ?? ''}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <PrimOutCheckbox value={selected} />
              {option.name}
            </React.Fragment>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                deleteIcon={<Close />}
                classes={{
                  root: classes.chipBgColor,
                  deleteIconSmall: classes.deleteIconSmall,
                }}
                label={option.name}
                size="small"
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              InputProps={{
                ...params.InputProps,
                classes: { inputMarginDense: classes.inputMarginDense },
                disableUnderline: true,
              }}
            />
          )}
        />
      </Box>
    </Box>
  );
};

export default MultiTagGroupAutocomplete;
